import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReachPanDirective } from './directive';

@NgModule({
	imports: [CommonModule, ReachPanDirective],
	exports: [ReachPanDirective],
})
export class ReachPanModule {}
